import Vue from 'vue'
import VueI18n from 'vue-i18n'
import App from './App.vue'
import router from './router'
import store from './store'
import elementUI from './plugins/element-ui'
import mixin from './mixins'
import ShowNoData from './components/ShowNoData'
import ImgPreview from './components/ImgPreview'
import zhCN from './lang/zh_CN'
import zhTW from './lang/zh_TW'
import zh_tran from './lang/lang'
import ElementLocale from 'element-ui/lib/locale'
import { get, post, deepClone } from './utils'
import './styles/index.scss'
// import './assets/css/global.scss'
// 全局变量
import global from '@/utils/global.js'
Vue.prototype.$get = get
Vue.prototype.$post = post
Vue.prototype.$deepClone = deepClone
Vue.prototype.$zh_tran = zh_tran
Vue.prototype.$global = global
Vue.prototype.formatWord = value => {
  return value.replace(/\n/g, '<br>')
}
Vue.use(elementUI)
Vue.use(VueI18n)
Vue.component('show-no-data', ShowNoData)
Vue.component('img-preview', ImgPreview)
Vue.mixin(mixin)
Vue.filter('handleClipSecond', time => {
  // 年月日时分秒 去除秒
  if (time && time.length === 19) {
    // 2021-08-11 11:11:11 一共19位
    return time.slice(0, 16)
  }
  return time
})

Vue.config.productionTip = false

const i18n = new VueI18n({
  locale: 'zhCN',
  messages: {
    zhCN,
    zhTW
  }
})
ElementLocale.i18n((key, value) => i18n.t(key, value))

new Vue({
  data: {
    global
  },
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
